import React from "react";
import { Skeleton } from "@components/Skeleton/Skeleton";

export const BudgetActionBarSkeleton: React.FC = () => {
  return (
    <React.Fragment>
      <Skeleton variant="rounded" className="hidden md:block md:w-44" />
      <div className="flex gap-3">
        <Skeleton variant="rounded" className="w-10 md:w-52" />
      </div>
    </React.Fragment>
  );
};
